import Translation from 'components/Translation'
import { useAppContext } from 'context/AppContext'
import { useAuth } from 'context/AuthContext'
import { useTenantContext } from 'context/TenantContext'
import { classNames } from 'utils/dom-helpers'
import { getTranslation } from 'utils/language-helper'
import { RoleTypes } from 'types/staff'
import { CalenderIcon, DeleteIcon } from 'utils/custom-icons'

export type StaffCardItemProps = {
    first_name: string
    last_name: string
    id: string
    staff_user_id: string
    staff_image: string
    has_existing_availability?: boolean
    onDelete?(): void
}

export function StaffCardItem({
    first_name,
    last_name,
    id,
    staff_user_id,
    staff_image,
    has_existing_availability,
    onDelete,
}: StaffCardItemProps) {
    const { StaffModal, hasRole } = useAuth()
    const { translations } = useAppContext()
    const { staff } = useTenantContext()
    const handleStaffSet = () => {
        const result = staff.find((s) => s.id == id)
        const { user } = result

        const mappedData = {
            id: result?.id,
            email: user?.email,
            first_name: user?.first_name,
            last_name: user?.last_name,
            phone: user?.phone,
            image_url: user?.image_url,
            role: user?.role,
            hourly_rate: result?.hourly_rate,
            user_id: user?.id,
            overtime_rate: result?.overtime_rate,
            monthly_rate: result?.monthly_rate,
            idx: 0,
            notes: result?.notes,
            created_at: result?.created_at
        }

        StaffModal.setAttributes({ ...mappedData, selected: hasRole([RoleTypes.ADMIN, RoleTypes.LOCATION_MANAGER, RoleTypes.SUPER_ADMIN]) ? 2 : 1 })
        StaffModal.open()
    }
    return (
        <div className="flex items-center gap-2 px-4 py-5 justify-between bg-white rounded-lg shadow-lg text-base">
            <div className="rounded-full w-10 h-10 overflow-hidden block bg-gray-100 flex items-center justify-center">
                {staff_image ? (
                    <img
                        className="max-w-full max-h-full"
                        src={staff_image}
                        alt="Staff Image"
                    />
                ) : (
                    <i className="feather-user text-xl text-primary" />
                )}
            </div>
            <div className="text-left flex-1 flex flex-col">
                <div>
                    {first_name} {last_name}
                </div>
            </div>
            <div className="flex items-center gap-2">
                <button
                    onClick={handleStaffSet}
                    type="button"
                    className=""
                    title={getTranslation(
                        has_existing_availability ? 'edit_availability' : 'set_availability',
                        translations
                    )}
                >
                    <CalenderIcon/>
                    {/* {has_existing_availability ?
                        <Translation
                            content_key='edit_availability'
                        />
                        :
                        <Translation
                            content_key='set_availability'
                        />
                    } */}

                </button>

                <button
                    disabled={has_existing_availability}
                    title={has_existing_availability ? getTranslation("services.delete_staff_availability_popup", translations) : undefined}
                    type="button"
                    onClick={onDelete}
                    className=''
                >
                    <DeleteIcon style={{ cursor: has_existing_availability ? "not-allowed" : "pointer" }}/>
                </button>
            </div>
        </div>
    )
}

export default StaffCardItem
